export const appLoadFailedMessage: string = 'The application is unavailable at the moment';

